import PropTypes from 'prop-types';

const ArrowLeft = ({ className = '', onClick, ...otherProps }) => {
  return (
  <svg className={`${className}`}  onClick={onClick} {...otherProps} width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12.8574" y="0.142578" width="3" height="18" rx="1.5" transform="rotate(45 12.8574 0.142578)" fill="#09101D"/>
    <rect x="0.129395" y="13.1289" width="3" height="18" rx="1.5" transform="rotate(-45 0.129395 13.1289)" fill="#09101D"/>
  </svg>


);
}

ArrowLeft.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default ArrowLeft;